import React from 'react';
import './SidebarRow.css';
import { Avatar } from '@material-ui/core';
function SidebarRow({ src, Icon, title}) {  //as per es6 structure we can use it(title or anything) instead of props
    return (
        <div className="sidebarRow">
         {src && <Avatar src={src} />}
         {Icon && <Icon />}
            <p>{title}</p>  
        </div>
    )
}

export default SidebarRow
